import { ContactTypeModel } from "./ContactType.model";

export class ContactsModel {
    public AreaCode: string;
    public ContactType: number;
    public CreatedBy: string;
    public CreatedDate: Date;
    public Email: string;
    public Id: number;
    public IdRequest: number;
    public ModifiedBy: string;
    public ModifiedDate: Date;
    public Name: string;
    public LastName: string;
    public Phone: string;
    public ContactTypeNavigation:ContactTypeModel;
}